<template>
    <div class="partner-page">
        <CpRequestAlert/>
        <Preview />
        <SearchResult v-if="user" :preview="true"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from "axios"
import { db, ELASTIC_SEARCH_CAMPAIGNS_INDEX } from '../../firebase'
import Preview from '@/components/wizard-steps/Preview'
import Card from '@/components/Card'
import SearchResult from "@/components/AdvancedSearch/SearchResult";
import CpRequestAlert from './CpRequestAlert'


export default {
    name: 'Campaign',
    components: {
        Preview,
        Card,
        SearchResult,
        CpRequestAlert
    },
    computed: {
        ...mapState([
            'user',
            'data',
            'relatedCategory'
        ]),
    },
    watch: {
        'relatedCategory': 'getRelated',
        '$route.params.campaignID': 'onPartnerChange'
    },
    mounted: function() {
        this.onPartnerChange()
    },
    updated() {
        this.getRelated()
    },
    methods: {
        onPartnerChange: function () {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            this.getRelated()
        },
        getRelated () {
            const campaignId = this.$route.params.campaignID || this.$route.query.id
            if(!campaignId){
                return
            }
            const category = this.relatedCategory
            const query = {
                bool: {
                    must: {
                        match: {
                            category
                        }
                    },
                    must_not: {
                        term: {
                            id: campaignId
                        },
                    },
                    filter: {
                        bool: {
                            must_not: {
                                exists: {
                                    field: 'hidden'
                                }
                            }
                        }
                    }
                }
            }

            axios
                .post(`https://search.crossprom.com/${ELASTIC_SEARCH_CAMPAIGNS_INDEX}/_search`, { size: 4, query })
                .then(response => {
                    // TODO: remove from store
                    // TODO: overall clean up search logic, remove from store
                    this.$store.commit(
                        'SET_SEARCH_RESULTS',
                        response.data.hits.hits.map(
                            (campaign) => campaign._source
                        )
                    )
                    this.$store.commit('SET', ['total', response.data.hits.hits.length])
                })
                .catch(console.error)
        },
    }
}
</script>

<style>
    div.camp-prev,
    div.update-schedule,
    div.promo-info-prev {
        width: 100%;
        max-width: 440px;
        height: 670px;
        padding: 0 15px;
        border-radius: 10px;
        box-shadow: 0px 0px 35px rgba(154, 161, 171, 0.15);
    }

    div.camp-prev,
    div.update-schedule {
        background: #FFFFFF;
    }
</style>
